import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute(
  '/auswahlfelder/genehmigungstatbestaende/',
)({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="ApprovalFacts"
      returnRoute="/auswahlfelder/approvalFacts"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const ApprovalFactsRoute = Route;
